// errorHandler.js

import { toast } from "react-toastify";
export const handleAxiosError = (error) => {
  const errorObj = typeof error === 'string' ? null : error;
  const errorMessage =
    typeof error === 'string' ? error : error?.response?.data?.message;

  const isTokenExpired = errorMessage === 'Token expired';
  const networkError = errorObj?.code === 'ERR_NETWORK';
  const isUnauthorized = errorObj?.response?.status === 401;

  if (networkError) {
    toast.error('Network Error');
    return;
  }

  if (isUnauthorized || errorMessage?.includes('Unauthorized') || isTokenExpired) {
    // Previously we dispatched Logout here which caused unexpected redirects.
    // Now we just surface a toast/console message so the user can decide what to do.
    toast.error(errorMessage || 'Unauthorized request');
    return;
  }

  if (errorMessage) {
    toast.error(errorMessage);
  }
};
